export const LIST_INCOME = 'LIST_INCOME';
export const LIST_INCOME_SUCCESS = 'LIST_INCOME_SUCCESS';
export const LIST_INCOME_ERROR = 'LIST_INCOME_ERROR';